(() => {
	angular.module('main').directive('settingsNav', settingsNav);

	settingsNav.$inject = [];

	function settingsNav() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: require('./settingsNav.component.html'),
			link() {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/navigation/settings-navbar/settingsNav.component.js